
import http from '@/assets/api/http';

// 骑手投保配置列表
export async function riderInsuranceList(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.PfInsureProductService.list',params,'POST');
}

// 骑手投保配置列表
export async function updateRiderInsuranceStatus(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.PfInsureProductService.updateStatus',params,'POST');
}